[
  {
    "label": "Awaiting approval",
    "value": "AWAITING_APPROVAL"
  },
  {
    "label": "Approved",
    "value": "APPROVED"
  },
  {
    "label": "Paid",
    "value": "PAID"
  },
  {
    "label": "Declined",
    "value": "DECLINED"
  }
]
